import React, { useEffect, useState, useRef } from 'react';
import defaultCursor from '../cursor/pointer.cur';
import pointerCursor from '../cursor/Spongebob.cur';

const CLICKABLE_SELECTORS = 'a, button, [role="button"], input[type="submit"], input[type="button"], select, label[for], .ambassador-card, .edition-card, .gallery-dot, .gallery-nav, .sponsor-card, nav ul li button, .nav-register-btn, .register-back-btn';

function CustomCursor() {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [isPointer, setIsPointer] = useState(false);
  const [isClicking, setIsClicking] = useState(false);
  const rafRef = useRef(null);
  const posRef = useRef({ x: -100, y: -100 });

  useEffect(() => {
    const onMouseMove = (e) => {
      posRef.current = { x: e.clientX, y: e.clientY };
      if (!rafRef.current) {
        rafRef.current = requestAnimationFrame(() => {
          setPosition(posRef.current);
          rafRef.current = null;
        });
      }

      // Check if hovering a clickable element
      const target = e.target;
      const clickable = target.closest(CLICKABLE_SELECTORS);
      setIsPointer(!!clickable);
    };

    const onMouseDown = () => setIsClicking(true);
    const onMouseUp = () => setIsClicking(false);

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mouseup', onMouseUp);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mouseup', onMouseUp);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <div
      className={`custom-cursor ${isPointer ? 'cursor-pointer' : 'cursor-default'} ${isClicking ? 'cursor-clicking' : ''}`}
      style={{
        left: position.x,
        top: position.y,
      }}
    >
      <img
        src={isPointer ? pointerCursor : defaultCursor}
        alt=""
        draggable={false}
      />
    </div>
  );
}

export default CustomCursor;
